export default "__VITE_ASSET__BV7Hxnbv__"